import * as React from 'react';
export function useCarouselContextValues_unstable(state) {
    const { activeIndex, selectPageByElement, selectPageByDirection, selectPageByIndex, subscribeForValues, enableAutoplay, resetAutoplay, circular, containerRef, viewportRef } = state;
    const carousel = React.useMemo(()=>({
            activeIndex,
            selectPageByElement,
            selectPageByDirection,
            selectPageByIndex,
            subscribeForValues,
            enableAutoplay,
            resetAutoplay,
            circular,
            containerRef,
            viewportRef
        }), [
        activeIndex,
        selectPageByElement,
        selectPageByDirection,
        selectPageByIndex,
        subscribeForValues,
        enableAutoplay,
        resetAutoplay,
        circular,
        containerRef,
        viewportRef
    ]);
    return {
        carousel
    };
}
